import { useQuery } from "@apollo/client/react";
import { CustomFieldsListDataDocument } from "#app/lib/data";
import { CUSTOM_FIELDS_VARS } from "#app/lib/data/workspace-data-provider";

/** The manage dialog's list: the same page the workspace provider holds. */
export function useCustomFieldsList(skip: boolean) {
  return useQuery(CustomFieldsListDataDocument, {
    variables: CUSTOM_FIELDS_VARS,
    skip,
  });
}

const CF_COUNT_VARIABLES = { limit: 1 } as const;

/**
 * Total custom fields in the workspace, ignoring any list filters — the
 * manage dialog swaps the whole table (toolbar included) for a first-run
 * empty state at zero. The mutations hook refetches every active
 * `CustomFieldsListData` observer, so the total tracks create/delete.
 */
export function useCustomFieldsCount() {
  const { data, loading } = useQuery(CustomFieldsListDataDocument, {
    variables: CF_COUNT_VARIABLES,
  });
  return {
    total: data?.customFields?.total,
    initialLoading: loading && !data,
  };
}
